module.exports = __webpack_public_path__ + "static/img/pc.80271a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/来华/pc.svg
// module id = /WSS
// module chunks = 16